var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#36394A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9136 11.8112L8.05762 8.7163L8.74268 8.0835L11.5996 11.1784C11.9055 11.5099 12.2767 11.7744 12.6899 11.9553C13.103 12.1362 13.5491 12.2296 14.0002 12.2296C14.4512 12.2296 14.8973 12.1362 15.3104 11.9553C15.7236 11.7744 16.0948 11.5099 16.4007 11.1784L19.2567 8.0835L19.9427 8.7163L17.0867 11.8112C16.6934 12.2374 16.2161 12.5775 15.6849 12.8101C15.1537 13.0427 14.5801 13.1628 14.0002 13.1628C13.4202 13.1628 12.8466 13.0427 12.3154 12.8101C11.7842 12.5775 11.3069 12.2374 10.9136 11.8112ZM16.4007 16.8214C16.0948 16.4899 15.7236 16.2254 15.3104 16.0445C14.8973 15.8636 14.4512 15.7702 14.0002 15.7702C13.5491 15.7702 13.103 15.8636 12.6899 16.0445C12.2767 16.2254 11.9055 16.4899 11.5996 16.8214L8.74362 19.9163L8.05762 19.2835L10.9136 16.1886C11.3069 15.7624 11.7842 15.4223 12.3154 15.1897C12.8466 14.957 13.4202 14.837 14.0002 14.837C14.5801 14.837 15.1537 14.957 15.6849 15.1897C16.2161 15.4223 16.6934 15.7624 17.0867 16.1886L19.9427 19.2835L19.2576 19.9163L16.4007 16.8214Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/XRP.8aef59f1b68f91922d0b75c6c9d1be3b.svg";
export { ForwardRef as ReactComponent };